import { OreStack } from "@edenredespana/oreneta"
import { useEffect } from "react"
import { useHelpCenter } from "@/HelpCenter/ui/context"
import {
    NewTicketHeader,
    ReopenTicketCancelModal,
    ReopenTicketForm,
    ReopenTicketFooter
} from '@/HelpCenter/ui/molecules'
import { useParams } from 'react-router-dom'

export const ReopenTicketFormContainer = () => {
    const { 
        getTicketDetail, 
        ticketDetail, 
        setIsReopenCancelModalOpen,
        isReopenCancelModalOpen,
        reopenForm 
    } = useHelpCenter()
    const { ticketId } = useParams<{ ticketId: string }>()

    useEffect(() => {
        if (ticketId) {
            getTicketDetail(ticketId).catch(error => {
                console.error('Error fetching ticket detail:', error)
            })
        }
    }, [ticketId])

    useEffect(() => {
        if (ticketDetail) {
            reopenForm.setValue('subject', ticketDetail.subject || '')
            reopenForm.setValue('description', ticketDetail.description || '')
            reopenForm.setValue('otherEmail', ticketDetail.otherEmail || '')
            reopenForm.setValue('otherPhone', ticketDetail.otherPhone || '')
        }
    }, [ticketDetail])

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <OreStack space="medium" placeContent="stretch">
                    <NewTicketHeader step={4} setIsModalOpen={setIsReopenCancelModalOpen} />
                    <ReopenTicketForm />
                    <ReopenTicketFooter />
                </OreStack>
            </div>
            <ReopenTicketCancelModal isModalOpen={isReopenCancelModalOpen} setIsModalOpen={setIsReopenCancelModalOpen} />
        </>
    )
}